import { render, staticRenderFns } from "./index.vue?vue&type=template&id=543d77ab&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=543d77ab&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543d77ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543d77ab')) {
      api.createRecord('543d77ab', component.options)
    } else {
      api.reload('543d77ab', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=543d77ab&scoped=true", function () {
      api.rerender('543d77ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/courseware/index.vue"
export default component.exports